var map = {
	"./config.base.json": "8/ZA",
	"./config.development.json": "tTI2",
	"./config.localdev.json": "NrRE",
	"./config.production.json": "WVLx"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "DYWz";


//////////////////
// WEBPACK FOOTER
// ./src/lib/config ^\.\/config\..*\.json$
// module id = DYWz
// module chunks = 1